import React from "react";
import "./Home.css";

function InductionStoves() {
  return (
    <div className="home-section-container">
      <div className="home-content-split">
        <div className="home-text-content">
          <div className="title-text-cont">
            <h1>INDUCTION STOVES</h1>
            <p className="home-subtitle">
              <img
                className="brandImg"
                src="/dometic.png"
              />
              <br />Dometic Double Element Induction Cooktop
            </p>
          </div>
        </div>

        <div className="home-image-content">
          <iframe src="https://drive.google.com/file/d/1DS4qpYsTq8Ugo448NjALGbLNtsD5bkxg/preview"></iframe>
        </div>
      </div>

      <div className="outdoorsy-container" style={{ textAlign: "left" }}>
        <p className="tealText">
          To operate the induction stove, hold the lock button until the red light turns off. Press the power button to turn on the stove. Select back or front surface. Press plus or minus buttons to choose heat level.
        </p>
        <p className="tealText">
          We recommend only using burners up to level 5 if using both at the same time. If the power cuts out when using two burners, flip the power strip under the sink (next to the water heater) back on.
        </p>
        <p className="tealText">
          When finished: press the power button to turn off the stove. Hold the lock button until the red light illuminates.
        </p>
        <p className="tealText">
          The stove surface gets hot very quickly and will stay hot for a while. Use caution!
        </p>
      </div>

      <div className="movCont">
        <img src="/stove.jpg" className="home-image" />
      </div>
    </div>
  );
}

export default InductionStoves;
